import { useState } from "react";
import Tabs from "../../../../components/elements/Tabs";
import OrganisationReports from "./OrganisationReports";
import { useTranslation } from "react-i18next";

export default function Reporting() {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);

  const tabsData = [
    {
      label: t("Organization Reports"),
      content: <OrganisationReports />,
    },
    // {
    //   label: "Scheduled Reports",
    //   content: <ScheduledReports />,
    // },
  ];

  return (
    <>
      <div className="w-full flex flex-col pb-10 bg-white rounded-md">
        <div className="space-y-4 py-8 px-5">
          <div className="mb-4 md:mb-8">
            <div className="flex flex-col gap-2 w-full">
              <h1 className="font-bold text-lg xl:text-2xl tracking-tighter uppercase text-slate-900 font-Montserrat">
                {t("Reporting")}
              </h1>
            </div>
          </div>

          <Tabs
            selectedIndex={selectedTab}
            items={tabsData}
            setSelectedIndex={(index) => {
              setSelectedTab(index);
            }}
            contentClass={"w-full"}
            tabsClass="gap-3 p-5 flex items-center gap-4 shadow-lg rounded-lg border-t border-slate-100"
            tabClass={
              "h-11 rounded-full bg-transparent border border-gray-200 flex items-center justify-center !text-deep-purple p-5 text-base capitalize font-normal"
            }
            activeTabClass={"bg-primary border border-primary !text-white"}
          />
        </div>
      </div>
    </>
  );
}
